import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import News from './pages/News';
import Kokkis from './pages/Kokkis';
import Avatars from './pages/Avatars';
import PowerupBank from './pages/PowerupBank';
import Bots from './pages/Bots';
import StandaloneGames from './pages/StandaloneGames';
import StandaloneGameCreate from './pages/StandaloneGameCreate';
import StandaloneGameDetail from './pages/StandaloneGameDetail';
import './App.css';

const NavLink = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const location = useLocation();
  const isActive = to === '/' ? location.pathname === to : location.pathname.startsWith(to);
  return (
    <Link to={to} className={`admin-nav-link ${isActive ? 'admin-nav-link-active' : ''}`}>{children}</Link>
  );
};

const Navigation = () => (
  <nav className="admin-navigation">
    <span className="admin-brand">Kokki Admin</span>
    <div className="admin-nav-scroll">
    <NavLink to="/">Dashboard</NavLink>
    <NavLink to="/standalone-games">Standalone Games</NavLink>
    <NavLink to="/users">Users</NavLink>
    <NavLink to="/news">News</NavLink>
    <NavLink to="/kokkis">Kokkis</NavLink>
    <NavLink to="/powerup-bank">Powerup Bank</NavLink>
    <NavLink to="/bots">Bots</NavLink>
    <NavLink to="/avatars">Avatars</NavLink>
    </div>
  </nav>
);

function AppContent() {
  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/standalone-games" element={<StandaloneGames />} />
        <Route path="/standalone-games/new" element={<StandaloneGameCreate />} />
        <Route path="/standalone-games/:gameType/:gameId" element={<StandaloneGameDetail />} />
        <Route path="/news" element={<News />} />
        <Route path="/kokkis" element={<Kokkis />} />
        <Route path="/powerup-bank" element={<PowerupBank />} />
        <Route path="/bots" element={<Bots />} />
        <Route path="/avatars" element={<Avatars />} />
      </Routes>
    </>
  );
}

function App() {
  console.log('App component rendering...');
  console.log(`Current port: ${window.location.port || '80/443'}`);
  console.log(`Host: ${window.location.host}`);

  return (
    <AuthGuard>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthGuard>
  );
}

export default App;
